<template>
    <div class="foote">
        <div class="foote_wrap">
            <ul class="foote_left">
                <li v-for="(item,index) in fotlist" :key="index" @click="onCon(index,item.url)">{{item.name}}</li>
            </ul>
            <div class="foote_right">© 2021 Artron. All rights reserved</div>
        </div>
        <div class="foote_h5bt">Copyright Reserved 2000-2021 雅昌艺术网 版权所有</div>
    </div>
</template>
<script>
export default {
    data(){
      return{
        fotlist:[
          {name:'HOME',url:'home'},
          {name:'NEWS',url:'news'},
          {name:'MARKET',url:'market'},
          {name:'INDEX',url:'index'},
          {name:'EXHIBITON',url:'exhibiton'},
          {name:'ARTIST',url:'artist'},
          {name:'ABOUT US',url:'aboutus'},
          {name:'中文版',url:'https://www.artron.net/'}]
      }
    },
  methods:{
    onCon(index,url){
      // this.actcon = index;
      if(index == 7){
        window.location.href = 'https://www.artron.net/';
      }else{
        this.$store.state.actcon = index;
        this.$router.push({name:url});
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.foote{
    /*position: fixed;*/
    /*left: 0;*/
    /*right: 0;*/
    /*bottom: 0;*/
    background: #262626;
    @media screen and(min-width: 1025px) {
        .foote_wrap{
            margin: 0 auto;
            max-width: 1180px;
            height: 120px;
            /*padding: 0 130px;*/
            display: flex;
            align-items: center;
            justify-content: space-between;
            .foote_left{
                display: flex;
                align-items: center;
                li{
                    font-size: 14px;
                    font-family: HelveticaNeue;
                    color: #A6A6A6;
                    margin-right: 40px;
                    cursor: pointer;
                }
                li:hover{
                    color: #F2F2F2;
                }
            }
            .foote_right{
                font-size: 14px;
                font-family: HelveticaNeue;
                color: #A6A6A6;
            }
        }
        .foote_h5bt{
            display: none;
        }
    }
    @media screen and(max-width: 1024px) {
        .foote_wrap{
            padding: 1.5rem 1.3rem 0.5rem;
            .foote_left{
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
                li{
                    width: 20%;
                    height: 1rem;
                    font-size: 0.6rem;
                    font-family: HelveticaNeue;
                    color: #A6A6A6;
                    text-align: center;
                    line-height: 1rem;
                    position: relative;
                    margin-bottom: 1rem;
                    margin-right: 1rem;
                }
                li:after{
                    content: "";
                    position: absolute;
                    top: 0.3rem;
                    right: -0.5rem;
                    width: 1px;
                    height: 0.35rem;
                    background: #404040;
                }
                li:nth-child(4n):after{
                    content: "";
                    width: 0;
                }
                li:nth-child(4n){
                    margin-right: 0;
                }
            }
            .foote_right{
                display: none;
            }
        }
        .foote_h5bt{
            text-align: center;
            border-top: 1px solid #404040;
            padding-top: 0.7rem;
            padding-bottom: 1.5rem;
            font-size: 0.6rem;
            color: #A6A6A6;
        }
    }
}
</style>